<template>
  <b-modal :id="title" v-model="isShowModal" hide-footer hide-header no-fade :size="size" no-close-on-backdrop>
    <div class="modalContents">
      <header class="basicModalHeader">
        <h6 class="basicModalTitle">{{ title }}</h6>
        <button class="basicModalBtnClose" @click="handClose">
          <img src="../../assets/svg/close.svg" alt="" height="14px" width="14px" />
        </button>
      </header>
      <div class="modalContent" :style="{ 'padding-bottom': !disabledFooter ? '60px' : '0px' }" id="basicModalText">
        <slot />

        <div v-if="!disabledFooter" class="mainModalFooter">
          <div>
            <slot name="footer">
              <template v-if="btnSubmitText">
                <MainButton :btnText="btnSubmitText" @click="handleSubmit" />
              </template>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import MainButton from "../button/MainButton.vue";

export default {
  name: "basicModal",
  props: {
    size: {
      type: String,
      default: "xl",
    },
    isShowModal: Boolean,
    title: String,
    btnSubmitText: String,
    handleSubmit: Function,
    disabledFooter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {};
  },
  watch: {
    itemSelected(newVal) {
      console.log("ItemSelected:", newVal);
    },
  },
  methods: {
    handClose() {
      this.$emit("close-modal");
    },
  },
  components: { MainButton },
};
</script>

<style scoped lang="scss">
.line {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
  border-bottom: 1px solid #d6d6d6 !important;
}

.modalContents {
  .basicModalHeader {
    background-color: #26336a;
    display: flex;
    justify-content: space-between;
    height: 48px;
    align-items: center;
    padding-left: 24px;
    padding-right: 10px;
    margin: -1rem;

    .basicModalTitle {
      color: #fff;
      font-size: 20px;
    }

    .basicModalBtnClose {
      height: 32px;
      width: 32px;
      padding: 0px;
      cursor: pointer;
      border-radius: 50%;
      border: 0px;
      background-color: transparent;
    }
  }

  .modalContent {
    margin: 16px;
    border-top: 1px solid #d6d6d6;
    margin-top: 24px;
    max-height: calc(100vh - 126px);
    overflow: auto;
    min-height: 200px;
  }

  .modalContent::-webkit-scrollbar {
    display: none;
  }
}
</style>
